import { createContext } from 'react'

const tipaltiContext = createContext()

export default tipaltiContext
